import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const RejectConfirmation = (props) => {
    const handleSubmit = () => {
        props.onClose();
        props.onSubmit();
    };
    return (
        <Box textAlign='center'>
            <Typography
                color='initial'
                sx={{ mx: 2, my: 4, lineHeight: '2rem', fontSize: '1.375rem' }}>
                Are you sure you want to reject this offer ?
            </Typography>
            <Button variant='contained' color='primary' onClick={() => handleSubmit()}>
                Reject Offer
            </Button>
        </Box>
    );
};

export default RejectConfirmation;
